module.exports = __webpack_public_path__ + "475ac20721d4b1ff2f9a94cf5a80ae04.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/pinterest.png
// module id = ./assets/thumbnails/pinterest.png
// module chunks = 2